<section class="home-client-feedback-component-wrapper">
  <h2>{{'home-page.client-feedback-headline' | translate}}</h2>

  <div class="home-client-feedback-component-wrapper_feedback-container">
      <app-client-feedback-card
        [clientFeedbacks]="clientFeedbacks"
      />
  </div>
</section>
